import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-100c7506"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ticket-your-event--section ticket-your-event--section--contact" }
const _hoisted_2 = { class: "ticket-your-event--section--contact--form" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  id: "get-in-contact",
  tabindex: "-1"
}, "Get in contact", -1))
const _hoisted_4 = { class: "article__content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Our Client Success team are available Monday to Friday (AEST) 8:30am-5:00pm, excluding public holidays. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "For other queries please use the form on this page.", -1))
const _hoisted_7 = { href: "tel:1300469849" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 1300 469 849")
const _hoisted_9 = { href: "mailto:admin@oztix.com.au" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" admin@oztix.com.au")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Can't make the event? Sell your tickets fast and fair through our resale partner ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Tixel!")
const _hoisted_13 = { class: "form-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_salesforce_lead_form = _resolveComponent("salesforce-lead-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("p", null, [
          _createElementVNode("a", _hoisted_7, [
            _createVNode(_component_font_awesome_icon, { icon: ['fa', 'phone'] }),
            _hoisted_8
          ])
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("a", _hoisted_9, [
            _createVNode(_component_font_awesome_icon, { icon: ['fa', 'envelope'] }),
            _hoisted_10
          ])
        ]),
        _createElementVNode("p", null, [
          _hoisted_11,
          _createVNode(_component_router_link, { to: "/resell-your-ticket" }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_salesforce_lead_form)
      ])
    ]),
    _createElementVNode("div", {
      class: "ticket-your-event--section--contact--decoration",
      style: _normalizeStyle({
        'background-image': `url('${require('@/assets/b2b/pattern-orange-bg.jpg')}')`,
      })
    }, null, 4)
  ]))
}